<template>
    <b-col class="animated fadeIn" sm="6">
        <b-card>
            <b-form @submit="save">
                <InputField type="email" name="email" :label="this.$t('email')" v-model="model.email"
                    @error="fieldError" :rules="{ required: true, length: { min: 2 } }" />

                <SelectField name="Role" :label="this.$t('role')" v-model="model.role_uuid" @error="fieldError"
                    :multiple="true" :items="roles" :rules="{ required: true }" />


                <b-form-group :label-cols="1" :horizontal="true">
                    <button class="btn btn-success pull-right" type="submit">{{ $t('save') }}</button>
                </b-form-group>
            </b-form>
        </b-card>
    </b-col>
</template>

<script>
import Input from "@/components/form/Input"
import Select from "@/components/form/Select"

export default {
    name: "Create",
    components: {
        InputField: Input,
        SelectField: Select
    },
    data: function () {
        return {
            errors: [],
            model: {
                email: "",
                role_uuid: []
            }
        }
    },

    computed: {
        items() {
            let project = this.$store.getters.getCurrentProject
            let users = []

            if (project.users !== undefined) {
                project.users.forEach(user => {
                    users.push(user.User)
                });
            }

            return users
        },

        roles() {
            let roles = this.$store.getters.getRoles
            roles.map(el => {
                el.text = el.name
                el.value = el.uuid
            })

            return roles
        }
    },
    methods: {
        save(e) {
            e.preventDefault()

            if (this.checkForErrors()) {
                this.$bvModal.msgBoxOk(this.$t('fieldsNotValid'))

                return
            }

            this.$http.post("/v1/project/invite", this.model).then((resp) => {

                this.$bvToast.toast("User invited", {
                    variant: 'success',
                    title: "Success"
                })

                this.$router.push({ path: "/admin/users" })
            }).catch(err => {
                if (err.response.status == 500) {
                    this.$serverErrorModal(err)
                    return
                }

                if (err.response.status == 409) {
                    this.$bvModal.msgBoxOk(this.$t('exceededLimit'))
                    return
                }

                this.$bvModal.msgBoxOk(err.response.data.message)
            })
        },

        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },
    },
    mounted() {
        this.$store.dispatch("fetchRoles").catch(error => {
            if (error.response.status == 500) {
                this.$serverErrorModal(error)
                return
            }

            this.$bvModal.msgBoxOk(error.response.data.message)
        })
    }
}
</script>
